export default "__VITE_ASSET__WNeymSFa__"